/**************************************************
 * Nombre:       Tarjeta_Fechas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import BotonGradiente from "../Componentes/BotonGradiente";
import {obtenerDia} from "../Utilidades/obtenerDia";
import {obtenerMes} from "../Utilidades/obtenerMes";
import {obtenerHora} from "../Utilidades/obtenerHora";

const Tarjeta_Fechas = ({item = {}, idLanding = '', cupos}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#F2F2F2', borderRadius: 6, p: 2}}

        >

            <Grid container size={{xs: 5, sm: 5, md: 5}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{borderRight: 4}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                        <Typography sx={{fontSize: 20, fontWeight: 800, textAlign: 'center'}}>
                            {obtenerDia(new Date(item.fecha).getDay())}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: -2}}>
                        <Typography sx={{fontSize: 48, fontWeight: 800, textAlign: 'center'}}>
                            {new Date(item.fecha).getDate()}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: -2}}>
                        <Typography sx={{fontSize: 20, fontWeight: 800, textAlign: 'center'}}>
                            {`de ${obtenerMes(new Date(item.fecha).getMonth())}`}
                        </Typography>
                    </Grid>


                </Grid>
            </Grid>

            <Grid container size={{xs: 7, sm: 7, md: 7}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{pl: 3}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: 1}}>
                        <Typography sx={{fontSize: 20, fontWeight: 800, textAlign: 'center'}}>
                            {`${obtenerHora(item.horaInicio)} a ${obtenerHora(item.horaFin)}`}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: 1}}>
                        <BotonGradiente idLanding={idLanding} cupos={cupos} fecha={item.fecha}/>
                    </Grid>


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Fechas